import React, { useState, useEffect } from 'react';
import { APIURL } from '../../../configApi/apiConfig';
import axios from "../../../configApi/axiosConfig";
import { DetalleCliente } from './DetalleCliente';
import { ModalLlamar } from './ModalLlamar';
import { ModalGestion } from './ModalGestion';
import { ModalGestiones } from './ModalGestiones';
import GroupIcon from '@mui/icons-material/Group';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PhoneIcon from '@mui/icons-material/Phone';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HistoryIcon from '@mui/icons-material/History';
import { enqueueSnackbar } from "notistack";
import { set } from 'react-hook-form';

export function GestionRecurrente() {
    const [clientes, setClientes] = useState([]);
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroBodega, setFiltroBodega] = useState('');
    const [filtroAsignado, setFiltroAsignado] = useState('');
    const [loading, setLoading] = useState(false);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarModalLlamar, setMostrarModalLlamar] = useState(false);
    const [mostrarModalGestion, setMostrarModalGestion] = useState(false);
    const [mostrarModalGestiones, setMostrarModalGestiones] = useState(false);
    const [gestiones, setGestiones] = useState([]);
    const [loadingGestiones, setLoadingGestiones] = useState(false);
    // Paginación
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [metaclientes, setMetaclientes] = useState({});
    const [totalSolicitudes, setTotalSolicitudes] = useState(0);
    const [totalClientesGestionados, setTotalClientesGestionados] = useState(0);
    const [bodegas, setBodegas] = useState([]);
    const [loadingBodegas, setLoadingBodegas] = useState(false);
    const [vendedores, setVendedores] = useState([]);
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState('');
    const [dataPeriodo, setDataPeriodo] = useState([]);
    const valorFechaPeriodo = periodoSeleccionado ? `${periodoSeleccionado}-01` : '';
    const hoy = new Date();
    const periodoActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
    const esPeriodoActual = periodoSeleccionado === periodoActual;

    // Cargar bodegas al montar el componente
    useEffect(() => {
        fetchbodegas();
    }, []);

    useEffect(() => {
        if (periodoSeleccionado) {
            fetchclientesgetsionbase(periodoSeleccionado);
        }
    }, [periodoSeleccionado]);

    const fetchbodegas = async () => {
        try {
            setLoadingBodegas(true);
            const response = await axios.get(APIURL.usuario_bodega_bodega_user());
            setBodegas(response.data || []);
        } catch (error) {
            console.error('Error al cargar bodegas:', error);
            enqueueSnackbar('Error al cargar las bodegas', { variant: 'error' });
            setBodegas([]);
        } finally {
            setLoadingBodegas(false);
        }
    };

    const fetchvendedores = async (Bodega) => {
        try {
            const response = await axios.get(APIURL.asigancionvendedoresforbodega(Bodega));
            setVendedores(response.data || []);
        } catch (error) {
            console.error('Error al cargar vendedores:', error);
            enqueueSnackbar('Error al cargar los vendedores', { variant: 'error' });
            setVendedores([]);
        }
    };

    const handlePeriodoChange = (e) => {
        console.log('Nuevo período seleccionado:', e.target.value);
        setPeriodoSeleccionado(e.target.value);
    };

    const handlePeriodoDateChange = (e) => {
        const valorFecha = e.target.value;
        const periodo = valorFecha ? valorFecha.slice(0, 7) : '';
        handlePeriodoChange({ target: { value: periodo } });
    };

    const formatearPeriodoMesAnio = (periodo) => {
        if (!periodo) return 'Sin período seleccionado';
        const fecha = new Date(`${periodo}-01T00:00:00`);
        if (Number.isNaN(fecha.getTime())) return 'Sin período seleccionado';
        return fecha.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
    };

    const fetchclientesgetsionbase = async (periodogestion) => {
        try {
            const periodo = await axios.get(APIURL.clientes_gestion_base_periodo(periodogestion));
            setDataPeriodo(periodo.data || []);
            if (!periodo.data || periodo.data.length === 0) {
                 enqueueSnackbar('No se encontró información para el período seleccionado', { variant: 'warning' });
                 setClientes([]);
                 setPageNumber(1);
                 setTotalPages(1);
                 setTotalRegistros(0);
                 setMetaclientes(0);
                 setTotalSolicitudes(0);
                 setTotalClientesGestionados(0);
            } else {
                 await handleBuscarCliente(1, periodo.data[0].sClienteBase);
            }
        } catch (error) {
            console.error('Error al cargar clientes por periodo:', error);
            enqueueSnackbar('Error al cargar clientes por periodo', { variant: 'error' });
            setDataPeriodo([]);
            setClientes([]);
            setPageNumber(1);
            setTotalPages(1);
            setTotalRegistros(0);
            setMetaclientes(0);
            setTotalSolicitudes(0);
            setTotalClientesGestionados(0);
        }
    };

    const ftechTelefono = async (sDetalleClientesGestionBase) => {
        try {
            const response = await axios.get(APIURL.clientes_gestion_base_telefono(sDetalleClientesGestionBase));
            return response.data || [];
        }
        catch (error) {
            console.error('Error al cargar teléfonos del cliente:', error);
            enqueueSnackbar('Error al cargar teléfonos del cliente', { variant: 'error' });
            return [];
        }
    };


    // Calcular estadísticas
    const vendedoresUnicos = [...new Set(clientes.map(c => c.asignado))];
    const totalClientesNoGestionados = Math.max(totalRegistros - totalClientesGestionados, 0);
    const totalClientesConsolidado = totalClientesGestionados + totalClientesNoGestionados;
    const metaClientesRedondeada = Math.round(metaclientes || 0);
    const totalCreditosVendidos = Number(totalSolicitudes) || 0;
    const porcentajeGestionadosSobreTotal = totalClientesConsolidado > 0
        ? (totalClientesGestionados / totalClientesConsolidado) * 100
        : 0;
    const porcentajeNoGestionadosSobreTotal = totalClientesConsolidado > 0
        ? (totalClientesNoGestionados / totalClientesConsolidado) * 100
        : 0;
    const donutDistribucionSize = 170;
    const donutDistribucionStroke = 16;
    const donutDistribucionRadius = (donutDistribucionSize - donutDistribucionStroke) / 2;
    const donutDistribucionCircunferencia = 2 * Math.PI * donutDistribucionRadius;
    const donutGestionadosLongitud = (porcentajeGestionadosSobreTotal / 100) * donutDistribucionCircunferencia;
    const donutNoGestionadosLongitud = donutDistribucionCircunferencia - donutGestionadosLongitud;
    const clientesPendientesMeta = Math.max(metaClientesRedondeada - totalCreditosVendidos, 0);
    const sobreMetaClientes = Math.max(totalCreditosVendidos - metaClientesRedondeada, 0);
    const porcentajeCumplimientoMeta = metaClientesRedondeada > 0
        ? Math.min((totalCreditosVendidos / metaClientesRedondeada) * 100, 100)
        : 0;
    const indicadorSize = 130;
    const indicadorStroke = 12;
    const indicadorRadius = (indicadorSize - indicadorStroke) / 2;
    const indicadorCircunferencia = 2 * Math.PI * indicadorRadius;
    const indicadorOffset = indicadorCircunferencia - (porcentajeCumplimientoMeta / 100) * indicadorCircunferencia;

    const clientesConAtraso = clientes.filter(c => c.atrasoPromedio < 0).length;

    const formatearFecha = (fechaString) => {
        const fecha = new Date(fechaString);
        return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const getAtrasoColor = (atraso) => {
        if (atraso > 0) return 'bg-red-50 text-red-700 border-red-200';
        if (atraso < 0) return 'bg-green-50 text-green-700 border-green-200';
        return 'bg-gray-50 text-gray-700 border-gray-200';
    };

    const handleVerDetalle = (cliente) => {
        setClienteSeleccionado(cliente);
        setMostrarModal(true);
    };

    const handleCerrarModal = () => {
        setMostrarModal(false);
        setClienteSeleccionado(null);
    };

    const handleAbrirLlamar = async (cliente) => {
        setClienteSeleccionado(cliente);
        setMostrarModalLlamar(true);
        
        // Cargar teléfonos del cliente
        if (cliente.sDetalleClientesGestionBase) {
            try {
                const telefonos = await ftechTelefono(cliente.sDetalleClientesGestionBase);
                // Actualizar el cliente con los teléfonos cargados
                setClienteSeleccionado({
                    ...cliente,
                    numerosContacto: telefonos.map(t => t.Celular)
                });
            } catch (error) {
                console.error('Error al cargar teléfonos:', error);
                // Si hay error, usar los teléfonos que ya tiene el cliente
                setClienteSeleccionado(cliente);
            }
        }
    };

    const handleCerrarLlamar = () => {
        setMostrarModalLlamar(false);
        setClienteSeleccionado(null);
    };

    const handleAbrirGestion = (cliente) => {
        setClienteSeleccionado(cliente);
        setMostrarModalGestion(true);
    };

    const handleCerrarGestion = () => {
        setMostrarModalGestion(false);
        setClienteSeleccionado(null);
    };

    const handleAbrirGestiones = async (cliente) => {
        setClienteSeleccionado(cliente);
        setMostrarModalGestiones(true);
        
        // Cargar gestiones del cliente
        if (cliente.sDetalleClientesGestionBase) {
            try {
                setLoadingGestiones(true);
                const response = await axios.get(
                    APIURL.gestiones_by_cliente_motivocontinuidad(cliente.sDetalleClientesGestionBase)
                );
                setGestiones(response.data || []);
            } catch (error) {
                console.error('Error al cargar gestiones:', error);
                enqueueSnackbar('Error al cargar el historial de gestiones', { variant: 'error' });
                setGestiones([]);
            } finally {
                setLoadingGestiones(false);
            }
        } else {
            setGestiones([]);
        }
    };

    const handleCerrarGestiones = () => {
        setMostrarModalGestiones(false);
        setClienteSeleccionado(null);
        setGestiones([]);
    };

    const handleGuardarGestion = async (gestion) => {
        try {
            if (!gestion) {
                throw new Error('No se encontró el identificador único de la estrategia');
            }

            await axios.post(APIURL.gestionesrecurrentesinsert(), gestion);
            enqueueSnackbar('Gestión guardada correctamente', { variant: 'success' });
            
            // Recargar la tabla después de guardar
            await handleBuscarCliente(pageNumber);
        } catch (error) {
            enqueueSnackbar('Error al guardar la gestión', { variant: 'error' });
            throw error;
        }
    };

    const handleBuscarCliente = async (page = 1, sClienteBaseOverride = null) => {
        try {
            const sClienteBase = sClienteBaseOverride || dataPeriodo?.[0]?.sClienteBase;

            // Validar que haya período seleccionado
            if (!sClienteBase) {
                enqueueSnackbar('Debe seleccionar un período antes de buscar', { variant: 'warning' });
                return;
            }

            setLoading(true);

            const buscar = {
                sClienteBase,
                Bodega: filtroBodega ? parseInt(filtroBodega) : 0,
                idVendedor: filtroAsignado ? parseInt(filtroAsignado) : 0,
                pageNumber: page,
                pageSize: 10,
                Filtro: filtroNombre.trim() || ''
            };



            const response = await axios.post(APIURL.postviewcbogestorescobranzasoperativo(), buscar);



            // Mapear y transformar los datos del API al formato esperado
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                // El API devuelve { data: [...], pageNumber, pageSize, totalPages, totalCount }
                const clientesTransformados = response.data.data.map(item => ({
                    nombre: item.Nombre || '',
                    numero: item.Numero || '',
                    ruc: item.Ruc || '',
                    celular: item.celular || '',
                    fechaFactura: item["Fecha Factura"] || item.FechaFactura || '',
                    bodegaAsignada: item["Bodega Asignada"] || item.BodegaAsignada || item.Bodega || '',
                    idBodega: item.idBodega || item.sBodegaId || item.Bodega || '',
                    vendedor: item.Vendedor || '',
                    asignado: item.Asignado || '',
                    almacen: item.Almacen || '',
                    atrasoPromedio: item.iAtrasoPromedio || 0,
                    fechaNacimiento: item.FechaNacimiento || '',
                    sDetalleClientesGestionBase: item.sDetalleClientesGestionBase || null,
                    sCre_SolicitudWeb: item.sCre_SolicitudWeb || null,
                    numerosContacto: item.numerosContacto || [item.celular],
                    ...item // Mantener todos los demás campos del API
                }));



                setClientes(clientesTransformados);
                setPageNumber(response.data.pageNumber || page);
                setPageSize(response.data.pageSize || 10);
                setTotalPages(response.data.totalPages || 1);
                setTotalRegistros(response.data.totalCount || 0);
                setMetaclientes((response.data.totalCount || 0) * 0.5);
                setTotalSolicitudes(response.data.totalSolicitudesWeb || 0);
                setTotalClientesGestionados(response.data.totalClientesGestionados || 0);

            } else {
                console.log('No se encontró data en la respuesta:', response.data);
                enqueueSnackbar('No se encontraron clientes', { variant: 'info' });
            }
        } catch (error) {
            console.error('Error al buscar cliente:', error);
            enqueueSnackbar('Error al buscar cliente: ' + (error.response?.data?.message || error.message), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-12">
            <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center gap-4 mb-2">
                        <div className="p-3 bg-gradient-to-br from-blue-400 to-indigo-400 rounded-full shadow-lg">
                            <GroupIcon className="text-white" sx={{ fontSize: 28 }} />
                        </div>
                        <div>
                            <h1 className="text-4xl font-bold text-gray-800">Clientes Recurrentes</h1>
                            <p className="text-gray-500 text-sm mt-1">Gestión y seguimiento de clientes frecuentes</p>
                        </div>
                    </div>
                </div>

                {/* Dashboard Único */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 mb-8">
                    <div className="flex items-center justify-between mb-6 rounded-xl border border-indigo-100 bg-gradient-to-r from-indigo-50 via-blue-50 to-cyan-50 px-4 py-3">
                        <div>
                            <p className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">Resumen general</p>
                        </div>
                        <div className="hidden md:flex items-center gap-2 rounded-lg bg-white/80 border border-indigo-100 px-3 py-2">
                            <span className="w-2.5 h-2.5 rounded-full bg-emerald-500" />
                            <span className="text-xs font-semibold text-gray-700">Cumplimiento: {porcentajeCumplimientoMeta.toFixed(1)}%</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mb-6">
                        <div className="rounded-xl border border-blue-100 bg-blue-50 p-4 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-blue-700">Total clientes</p>
                                    <p className="text-2xl font-bold text-blue-600">{totalClientesConsolidado}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-blue-100">
                                    <PeopleIcon className="text-blue-600" sx={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                         <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-indigo-700">Meta clientes</p>
                                    <p className="text-2xl font-bold text-indigo-600">{metaClientesRedondeada}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-indigo-100">
                                    <AssignmentIcon className="text-indigo-600" sx={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                        <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-emerald-700">Clientes gestionados</p>
                                    <p className="text-2xl font-bold text-emerald-600">{totalClientesGestionados}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-emerald-100">
                                    <PhoneIcon className="text-emerald-600" sx={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                        <div className="rounded-xl border border-rose-100 bg-rose-50 p-4 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-rose-700">Clientes no gestionados</p>
                                    <p className="text-2xl font-bold text-rose-600">{totalClientesNoGestionados}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-rose-100">
                                    <AccessTimeIcon className="text-rose-600" sx={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                        <div className="rounded-xl border border-violet-100 bg-violet-50 p-4 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-violet-700">Créditos Facturados</p>
                                    <p className="text-2xl font-bold text-violet-600">{totalCreditosVendidos}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-violet-100">
                                    <CreditCardIcon className="text-violet-600" sx={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                       
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="rounded-xl border border-gray-200 p-4">
                            <p className="text-sm font-semibold text-gray-700 mb-3">Distribución de clientes (sobre total)</p>

                            <div className="flex flex-col items-center justify-center">
                                <div className="relative" style={{ width: donutDistribucionSize, height: donutDistribucionSize }}>
                                    <svg width={donutDistribucionSize} height={donutDistribucionSize} className="-rotate-90">
                                        <circle
                                            cx={donutDistribucionSize / 2}
                                            cy={donutDistribucionSize / 2}
                                            r={donutDistribucionRadius}
                                            stroke="#e5e7eb"
                                            strokeWidth={donutDistribucionStroke}
                                            fill="none"
                                        />
                                        <circle
                                            cx={donutDistribucionSize / 2}
                                            cy={donutDistribucionSize / 2}
                                            r={donutDistribucionRadius}
                                            stroke="#10b981"
                                            strokeWidth={donutDistribucionStroke}
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeDasharray={`${donutGestionadosLongitud} ${donutNoGestionadosLongitud}`}
                                            strokeDashoffset="0"
                                        />
                                        <circle
                                            cx={donutDistribucionSize / 2}
                                            cy={donutDistribucionSize / 2}
                                            r={donutDistribucionRadius}
                                            stroke="#f43f5e"
                                            strokeWidth={donutDistribucionStroke}
                                            fill="none"
                                            strokeLinecap="butt"
                                            strokeDasharray={`${donutNoGestionadosLongitud} ${donutGestionadosLongitud}`}
                                            strokeDashoffset={-donutGestionadosLongitud}
                                        />
                                    </svg>
                                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                                        <span className="text-2xl font-bold text-gray-800">{totalClientesConsolidado}</span>
                                        <span className="text-xs text-gray-500">Total clientes</span>
                                    </div>
                                </div>

                                <div className="mt-4 w-full space-y-2">
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="inline-flex items-center gap-2 text-gray-700">
                                            <span className="w-3 h-3 rounded-full bg-emerald-500" /> Gestionados
                                        </span>
                                        <span className="font-semibold text-emerald-600">{porcentajeGestionadosSobreTotal.toFixed(1)}% ({totalClientesGestionados})</span>
                                    </div>
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="inline-flex items-center gap-2 text-gray-700">
                                            <span className="w-3 h-3 rounded-full bg-rose-500" /> No gestionados
                                        </span>
                                        <span className="font-semibold text-rose-600">{porcentajeNoGestionadosSobreTotal.toFixed(1)}% ({totalClientesNoGestionados})</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="rounded-xl border border-gray-200 p-4">
                            <p className="text-sm font-semibold text-gray-700 mb-3">Cumplimiento de meta (Créditos Facturados)</p>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                                <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
                                    <p className="text-xs text-indigo-700">Meta Clientes</p>
                                    <p className="text-3xl font-bold text-indigo-600">{metaClientesRedondeada}</p>
                                    <p className="text-xs text-gray-600 mt-1">100% del objetivo</p>

                                    <div className="mt-3">
                                        <p className="text-xs text-gray-600 mb-1">Avance por Créditos Facturados</p>
                                        <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                                            <div className="h-full bg-gradient-to-r from-violet-500 to-purple-500 transition-all duration-500" style={{ width: `${porcentajeCumplimientoMeta}%` }} />
                                        </div>
                                        <p className="text-xs text-violet-700 mt-1 font-semibold">{porcentajeCumplimientoMeta.toFixed(1)}%</p>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center justify-center">
                                    <p className="text-xs text-gray-600 mb-2">Cumplimiento de meta</p>
                                    <div className="relative" style={{ width: indicadorSize, height: indicadorSize }}>
                                        <svg width={indicadorSize} height={indicadorSize} className="-rotate-90">
                                            <circle
                                                cx={indicadorSize / 2}
                                                cy={indicadorSize / 2}
                                                r={indicadorRadius}
                                                stroke="#e5e7eb"
                                                strokeWidth={indicadorStroke}
                                                fill="none"
                                            />
                                            <circle
                                                cx={indicadorSize / 2}
                                                cy={indicadorSize / 2}
                                                r={indicadorRadius}
                                                stroke="#f59e0b"
                                                strokeWidth={indicadorStroke}
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeDasharray={indicadorCircunferencia}
                                                strokeDashoffset={indicadorOffset}
                                            />
                                        </svg>
                                        <div className="absolute inset-0 flex flex-col items-center justify-center">
                                            <span className="text-2xl font-bold text-amber-600">{porcentajeCumplimientoMeta.toFixed(1)}%</span>
                                            <span className="text-xs text-gray-500">Cumplido</span>
                                        </div>
                                    </div>
                                    <p className="mt-2 text-sm text-gray-700">
                                        {clientesPendientesMeta} por completar
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        Cálculo: meta clientes - Créditos Facturados
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {sobreMetaClientes > 0 && (
                        <p className="mt-4 text-sm text-blue-700 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
                            Se superó la meta en <span className="font-semibold">{sobreMetaClientes}</span> Créditos Facturados.
                        </p>
                    )}
                </div>

            

                {/* Filtros */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 mb-8">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                        {/* Filtro por Período */}
                        <div>
                            <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                                📅 Filtrar por Período (Año-Mes)
                            </label>
                            <input
                                type="date"
                                value={valorFechaPeriodo}
                                onChange={handlePeriodoDateChange}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-purple-500 focus:ring-purple-200 transition-all bg-white hover:border-gray-300 cursor-pointer"
                            />
                            <p className="mt-2 text-xs text-gray-500 capitalize">
                                Período seleccionado: {formatearPeriodoMesAnio(periodoSeleccionado)}
                            </p>
                        </div>
                        {/* Filtro por Nombre */}
                        <div>
                            <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                                <SearchIcon sx={{ fontSize: 18 }} /> Buscar por Nombre
                            </label>
                            <input
                                type="text"
                                value={filtroNombre}
                                onChange={(e) => setFiltroNombre(e.target.value)}
                                placeholder="Ingrese nombre del cliente..."
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-blue-500 focus:ring-blue-200 transition-all"
                            />
                        </div>

                        {/* Filtro por Bodega */}
                        <div>
                            <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                                <BusinessIcon sx={{ fontSize: 18 }} /> Filtrar por Bodega
                            </label>
                            <select
                                value={filtroBodega}
                                onChange={(e) => {
                                    setFiltroBodega(e.target.value);
                                    if (e.target.value) {
                                        fetchvendedores(e.target.value);
                                    } else {
                                        setVendedores([]);
                                        setFiltroAsignado('');
                                    }
                                }}
                                disabled={loadingBodegas}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-blue-500 focus:ring-blue-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <option value="">{loadingBodegas ? 'Cargando bodegas...' : 'Todas las bodegas'}</option>
                                {bodegas.map(bodega => (
                                    <option key={bodega.b_Bodega} value={bodega.b_Bodega}>{bodega.b_Nombre}</option>
                                ))}
                            </select>
                        </div>

                        {/* Filtro por Asignado */}
                        <div>
                            <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                                <PersonIcon sx={{ fontSize: 18 }} /> Filtrar por Vendedor
                            </label>
                            <select
                                value={filtroAsignado}
                                onChange={(e) => setFiltroAsignado(e.target.value)}
                                disabled={!filtroBodega || vendedores.length === 0}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-blue-500 focus:ring-blue-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {!filtroBodega
                                        ? 'Seleccione primero una bodega'
                                        : vendedores.length === 0
                                            ? 'No hay vendedores disponibles'
                                            : 'Todos los vendedores'}
                                </option>
                                {vendedores.map(vendedor => {
                                    const nombreCompleto = `${vendedor.nomina.PrimerNombre} ${vendedor.nomina.SegundoNombre || ''} ${vendedor.nomina.ApellidoPaterno} ${vendedor.nomina.ApellidoMaterno}`.trim().replace(/\s+/g, ' ');
                                    return (
                                        <option key={vendedor.idPersonal} value={vendedor.idPersonal}>
                                            {nombreCompleto}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                    </div>

                    {/* Botones de acción */}
                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={() => {
                                setFiltroNombre('');
                                setFiltroBodega('');
                                setFiltroAsignado('');
                                setPeriodoSeleccionado('');
                                setDataPeriodo([]);
                                setClientes([]);
                                setPageNumber(1);
                                setTotalPages(1);
                                setTotalRegistros(0);
                                setVendedores([]);
                            }}
                            disabled={loading}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <CloseIcon sx={{ fontSize: 18 }} />
                            Limpiar Filtros
                        </button>
                        <button
                            onClick={() => handleBuscarCliente(1)}
                            disabled={loading || !periodoSeleccionado || dataPeriodo.length === 0}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                            title={!periodoSeleccionado ? 'Debe seleccionar un período primero' : 'Buscar clientes'}
                        >
                            <SearchIcon sx={{ fontSize: 18 }} />
                            {loading ? 'Buscando...' : 'Buscar Clientes'}
                        </button>
                    </div>
                </div>

                {/* Controles de Paginación */}
                {totalPages > 1 && (
                    <div className="bg-white rounded-2xl p-4 shadow-lg border border-gray-100 mb-8 flex items-center justify-between">
                        <div className="text-sm text-gray-600">
                            Mostrando página <span className="font-bold text-blue-600">{pageNumber}</span> de{' '}
                            <span className="font-bold">{totalPages}</span> • Total de registros:{' '}
                            <span className="font-bold text-blue-600">{totalRegistros}</span>
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={() => handleBuscarCliente(pageNumber - 1)}
                                disabled={pageNumber === 1 || loading}
                                className="px-4 py-2 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                            >
                                ← Anterior
                            </button>
                            <div className="flex items-center gap-2">
                                {Array.from({ length: Math.min(5, totalPages) }).map((_, idx) => {
                                    const page = Math.max(1, pageNumber - 2) + idx;
                                    if (page > totalPages) return null;
                                    return (
                                        <button
                                            key={page}
                                            onClick={() => handleBuscarCliente(page)}
                                            disabled={loading}
                                            className={`px-3 py-2 rounded-lg font-semibold transition-all ${pageNumber === page
                                                ? 'bg-blue-600 text-white shadow-md'
                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                } disabled:opacity-50`}
                                        >
                                            {page}
                                        </button>
                                    );
                                })}
                            </div>
                            <button
                                onClick={() => handleBuscarCliente(pageNumber + 1)}
                                disabled={pageNumber === totalPages || loading}
                                className="px-4 py-2 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                            >
                                Siguiente →
                            </button>
                        </div>
                    </div>
                )}

                {/* Tabla */}
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 border-b border-gray-200">
                                <tr>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Cliente</th>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">RUC</th>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Celular</th>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Bodega</th>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Vendedor</th>
                                    <th className="px-4 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Asignado</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Atraso Prom.</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Cuota Pre-Aprobada</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Detalle Gestión</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Estado</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Fecha Factura</th>
                                    <th className="px-4 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {clientes.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" className="px-6 py-12 text-center">
                                            <div className="flex flex-col items-center gap-3">
                                                <span className="text-5xl">📭</span>
                                                <p className="text-gray-500 text-sm font-medium">No se encontraron clientes con los filtros seleccionados</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    clientes.map((cliente, idx) => (
                                        <tr key={idx} className="hover:bg-blue-50 transition-all duration-200">
                                            <td className="px-4 py-4">
                                                <div>
                                                    <p className="text-sm font-semibold text-gray-800">{cliente.nombre}</p>
                                                    <p className="text-xs text-gray-500">Nº {cliente.numero}</p>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-700">{cliente.ruc}</td>
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center gap-1 text-sm text-blue-600 font-medium">
                                                    <PhoneIphoneIcon sx={{ fontSize: 16 }} /> {cliente.celular}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center px-3 py-1 rounded-full bg-purple-50 text-purple-700 font-semibold text-xs border border-purple-200">
                                                    {cliente.bodegaAsignada}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4 text-sm text-gray-700">{cliente.vendedor}</td>
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-50 text-green-700 font-semibold text-xs border border-green-200">
                                                    {cliente.asignado}
                                                </span>
                                            </td>
                                            <td className="px-4 py-4 text-center">
                                                <span className={`inline-flex items-center px-3 py-1 rounded-full font-semibold text-xs border ${getAtrasoColor(cliente.atrasoPromedio)}`}>
                                                    {cliente.atrasoPromedio > 0 ? '+' : ''}{cliente.atrasoPromedio}d
                                                </span>
                                            </td>
                                            {/* Cuota Pre-Aprobada  90 default */}
                                            <td className="px-4 py-4 text-center">
                                                <span
                                                    className={`inline-flex items-center px-3 py-1 rounded-full bg-${cliente.sCre_SolicitudWeb ? 'green' : 'gray'}-50 text-${cliente.sCre_SolicitudWeb ? 'green' : 'gray'}-700 font-semibold text-xs border border-${cliente.sCre_SolicitudWeb ? 'green' : 'gray'}-200`}
                                                >
                                                   90
                                                </span>
                                            </td>
                                            <td className="px-4 py-4">
                                                <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-50 text-green-700 font-semibold text-xs border border-green-200">
                                                    {cliente.Motivo ? cliente.Motivo : '--'}
                                                </span>
                                            </td>

                                            <td className="px-4 py-4 text-center">
                                                {cliente.sCre_SolicitudWeb !== null ? (
                                                    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 font-bold text-xs border border-emerald-200 shadow-sm">
                                                        <CreditCardIcon sx={{ fontSize: 16 }} />
                                                        Facturado
                                                    </span>
                                                ) : (
                                                    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gray-50 text-gray-500 font-semibold text-xs border border-gray-200">
                                                        <CloseIcon sx={{ fontSize: 16 }} />
                                                        Sin Facturar
                                                    </span>
                                                )}
                                            </td>
                                            <td className="px-4 py-4 text-center text-sm text-gray-600">
                                                {formatearFecha(cliente.fechaFactura)}
                                            </td>
                                            <td className="px-4 py-4 text-center">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => handleAbrirLlamar(cliente)}
                                                        className="inline-flex items-center gap-1 px-3 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-semibold rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-200 shadow-md hover:shadow-lg"
                                                        title="Numeros de Contacto"
                                                    >
                                                        <PhoneIcon sx={{ fontSize: 14 }} />
                                                        
                                                    </button>
                                                    <button
                                                        onClick={() => handleAbrirGestion(cliente)}
                                                        disabled={!esPeriodoActual}
                                                        className="inline-flex items-center gap-1 px-3 py-2 bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-xs font-semibold rounded-lg hover:from-purple-600 hover:to-indigo-600 transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:from-gray-400 disabled:to-gray-500"
                                                        title={esPeriodoActual ? "Registrar Gestión" : "Solo disponible para el período del mes en curso"}
                                                    >
                                                        <AssignmentIcon sx={{ fontSize: 14 }} />
                                                        
                                                    </button>
                                                    <button
                                                        onClick={() => handleAbrirGestiones(cliente)}
                                                        className="inline-flex items-center gap-1 px-3 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-semibold rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all duration-200 shadow-md hover:shadow-lg"
                                                        title="Ver Gestiones"
                                                    >
                                                        <HistoryIcon sx={{ fontSize: 14 }} />
                                                        
                                                    </button>
                                                    <button
                                                        onClick={() => handleVerDetalle(cliente)}
                                                        className="inline-flex items-center gap-1 px-3 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white text-xs font-semibold rounded-lg hover:from-blue-600 hover:to-indigo-600 transition-all duration-200 shadow-md hover:shadow-lg"
                                                        title="Ver Detalle"
                                                    >
                                                        <VisibilityIcon sx={{ fontSize: 14 }} />
                                                        
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer con total de resultados */}
                <div className="mt-4 text-center text-sm text-gray-600">
                    Mostrando <span className="font-bold text-blue-600">{clientes.length}</span> de{' '}
                    <span className="font-bold">{pageSize}</span> clientes en página{' '}
                    <span className="font-bold text-blue-600">{pageNumber}</span>
                    {totalRegistros > 0 && (
                        <> • Total: <span className="font-bold">{totalRegistros}</span></>
                    )}
                </div>

                {/* Modal de Detalle del Cliente */}
                <DetalleCliente
                    cliente={clienteSeleccionado}
                    mostrarModal={mostrarModal}
                    onCerrar={handleCerrarModal}
                />

                {/* Modal de Llamar */}
                <ModalLlamar
                    cliente={clienteSeleccionado}
                    mostrarModal={mostrarModalLlamar}
                    onCerrar={handleCerrarLlamar}
                />

                {/* Modal de Gestión */}
                <ModalGestion
                    cliente={clienteSeleccionado}
                    mostrarModal={mostrarModalGestion}
                    onCerrar={handleCerrarGestion}
                    onGuardar={handleGuardarGestion}
                />

                {/* Modal de Historial de Gestiones */}
                <ModalGestiones
                    cliente={clienteSeleccionado}
                    mostrarModal={mostrarModalGestiones}
                    onCerrar={handleCerrarGestiones}
                    gestiones={gestiones}
                />
            </div>
        </div>
    );
}